import useTranslator from "../../hooks/useTranslator";
import { useContext, useEffect, useState } from "react";
import { haveValue, streetTypes, toast } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
import AuthStepHeader from "../Auth/AuthStepHeader";
import {
  RowButton,
  Button,
  Icon,
  Select,
  SearchSelect,
  TextField,
} from "../design";
import provincesData from "../../Utils/provincia_municipios.json";
import "./addPropertyModal.css";
import "./cadastre.css";

const Cadastre = (props) => {
  const {
    step,
    setStep,
    handleShow,
    formData,
    setFormData,
    handleInputChange,
    defaultState,
    handleSubmit,
    handleBackCurrent = null,
    isLandlord = false,
  } = props;

  const { _t } = useTranslator();
  const landLordContext = useContext(LandLordContext);
  const authContext = useContext(AuthContext);
  const { setLoading } = authContext;
  const { validateCadastre, getBuildingData, properties, getAutoCompleteList } =
    landLordContext;

  const [floorVals, setFloorVals] = useState([]);
  const [fromRef, setFromRef] = useState(false);
  const [autoCompleteList, setAutoCompleteList] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [changeEntered, setChangeEntered] = useState(false);
  const [enteredAddress, setEnteredAddress] = useState("");
  const [doorVals, setDoorVals] = useState([]);
  const [allCadastre, setAllCadastre] = useState([]);
  const [showRequired, setShowRequired] = useState(false);

  useEffect(() => {
    if (!changeEntered) {
      const timeoutId = setTimeout(async () => {
        getAutoCompleteList(enteredAddress)
          .then((res) => {
            if (
              haveValue(res?.from_ref) &&
              res?.from_ref == true &&
              res?.results.length > 0
            ) {
              setFromRef(true);
              const val = res?.results[0];
              const temp_data = { ...formData };
              // const temp = {
              temp_data.street_type = val?.tipo_via;
              temp_data.street = val?.via;
              temp_data.street_number = val?.numero_via;
              temp_data.postcode = val?.cp;
              temp_data.staircase = val?.escalera;
              temp_data.floor = val?.piso;
              temp_data.door = val?.puerta;
              temp_data.municipality = val?.municipio;
              temp_data.province = val?.provincia;
              temp_data.code_ine = val?.cod_ine;
              temp_data.code_via = val?.cod_via;
              temp_data.cadastral_reference = val?.referencia_catastral;
              temp_data.area = val?.sup_util;
              // };
              setFormData(temp_data);
              setIsSelected(true);
            } else {
              setFromRef(false);
              if (haveValue(enteredAddress) && res.length == 0) {
                const not_listed = [{ address: "not_found_property" }];
                setAutoCompleteList(not_listed);
              } else {
                setAutoCompleteList(res);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [enteredAddress]);

  const handleValidateCadastre = async (e) => {
    e.preventDefault();
    if (fromRef == true) {
      handleShow();
    } else {
      if (
        haveValue(formData?.code_ine) &&
        haveValue(formData?.code_via) &&
        haveValue(formData?.street_number)
      ) {
        validateCadastre(
          formData.code_ine,
          formData?.code_via,
          formData?.street_number
        )
          .then((res) => {
            const temp_data = { ...formData };
            temp_data.street_type = res[0].tipo_via;
            temp_data.street = res[0].via;
            temp_data.postcode = res[0].cp;
            temp_data.municipality = res[0].municipio;
            temp_data.province = res[0].provincia;
            if (haveValue(res[0].referencia_catastral)) {
              temp_data.cadastral_reference = res[0].referencia_catastral;
              setFormData(temp_data);
              fetchBuildingData(res[0].referencia_catastral);
            } else {
              setFormData(temp_data);
              handleRedirectManual();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const fetchBuildingData = async (cadastral_reference) => {
    getBuildingData(
      cadastral_reference,
      formData.code_via,
      formData.street_number
    )
      .then((res) => {
        if (res.length == 1 && !haveValue(res[0].vertical)) {
          setFormData((prev) => ({ ...prev, area: res[0].sup_util }));
          setStep(3);
        } else if (res.length == 0) {
          setStep(3);
        } else {
          const highestFloor = [
            ...new Set(res.map((item) => item.piso)),
          ].sort();
          const highestLetter = {};
          res.forEach((item) => {
            const piso = item.piso;
            const puerta = item.puerta;

            if (!(piso in highestLetter)) {
              highestLetter[piso] = [];
            }
            highestLetter[piso][`${puerta}`] = item;
          });

          setAllCadastre(res);

          setFloorVals(highestFloor);
          setDoorVals(highestLetter);

          handleNext();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addVals = () => {
    setLoading(true);
    const check = properties.filter(
      (prop) =>
        prop?.street == `${formData?.street_type}, ${formData?.street}` &&
        prop?.street_number == formData?.street_number &&
        prop?.floor_number == formData?.floor &&
        prop?.flat_number == formData?.door
    );

    if (check.length > 0) {
      toast.error(_t("propertyAlreadyExists"));
    } else {
      const current_selected = doorVals[formData.floor][formData.door];
      const temp_cadastre = allCadastre.filter(
        (item) => item.piso == formData.floor && item.puerta == formData.door
      );

      setFormData((prev) => ({
        ...prev,
        area: current_selected.sup_util,
        staircase: current_selected.escalera,
        cadastral_reference: temp_cadastre[0]?.referencia_catastral,
      }));
      handleShow();
    }
    setLoading(false);
  };

  const handleFloorInput = async (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      area: doorVals[formData?.floor][formData?.door].sup_util,
    }));
  };

  const handleSelectAddr = (ele) => {
    const code_ine = ele?.cod_ine;
    const code_via = ele?.cod_via;
    const entered_address = `${ele?.tipo_via} ${ele?.via}, ${ele?.address_2}`;
    setEnteredAddress(entered_address);
    setChangeEntered(true);
    const street_number = haveValue(ele?.numero_via) ? ele.numero_via : "";
    setFormData((prevData) => ({
      ...prevData,
      ...defaultState,
      code_ine,
      code_via,
      street_number,
    }));
    setIsSelected(true);
  };

  const handleAddressType = (e) => {
    setChangeEntered(false);
    setEnteredAddress(e.target.value);
    setFormData((prevData) => ({ ...prevData, code_ine: "", code_via: "" }));
  };

  const handleNext = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleGoBack = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const handleRedirectManual = () => {
    setStep(3);
  };

  const setField = (name, value) =>
    handleInputChange({ target: { name, value } });

  const getRequiredMessage = (labelKey) => {
    const translatedRequiredSuffix = _t("isRequired");
    const requiredSuffix =
      translatedRequiredSuffix === "isRequired"
        ? "is required"
        : translatedRequiredSuffix;
    return `${_t(labelKey)} ${requiredSuffix}`;
  };

  // A value that came from the cadastre (for example "CL" or "MADRID") may not
  // be in our lists; keep it in the options so the field still shows it.
  const withCurrent = (options, current) =>
    haveValue(current) &&
    current !== "" &&
    !options.some((option) => option.value === current)
      ? [{ value: current, label: current }, ...options]
      : options;

  const streetTypeOptions = withCurrent(
    streetTypes.map((type) => ({ value: type, label: type })),
    formData?.street_type
  );
  const provinceOptions = withCurrent(
    provincesData.map((p) => ({ value: p.Provincia, label: p.Provincia })),
    formData?.province
  );
  const normalize = (text) => String(text ?? "").toLowerCase();
  const selectedProvince = provincesData.find(
    (p) => normalize(p.Provincia) === normalize(formData?.province)
  );
  const municipalityOptions = withCurrent(
    (selectedProvince?.municipios || []).map((m) => ({ value: m, label: m })),
    formData?.municipality
  );

  const handleManualSubmit = (e) => {
    e.preventDefault();
    if (
      !haveValue(formData?.street_type) ||
      !haveValue(formData?.municipality) ||
      !haveValue(formData?.province)
    ) {
      setShowRequired(true);
      return;
    }
    handleSubmit(e);
  };

  const requiredError = (name, labelKey) =>
    showRequired && !haveValue(formData?.[name])
      ? getRequiredMessage(labelKey)
      : undefined;

  const subtitles = {
    1: _t("cadastreSearchSub"),
    2: _t("cadastreFloorSub"),
    3: _t("cadastreManualSub"),
  };

  const backHandlers = {
    1: haveValue(handleBackCurrent) ? handleBackCurrent : null,
    2: handleGoBack,
    3: () => setStep(1),
    4: handleGoBack,
  };

  const title =
    step === 4 ? `${_t("municipalityAndProvince")}?` : _t("whatIsYourAddress");

  if (step === 5) return null;

  const header = backHandlers[step] ? (
    <AuthStepHeader
      onBack={backHandlers[step]}
      title={title}
      subtitle={subtitles[step]}
    />
  ) : (
    <header className="auth-step-header">
      <h2 className="auth-step-title">{title}</h2>
      {subtitles[step] && <p className="auth-step-sub">{subtitles[step]}</p>}
    </header>
  );

  return (
    <div className="cadastre">
      {header}
      {step === 1 && (
        <form className="cadastre__form" onSubmit={handleValidateCadastre}>
          <div className="property-form__row">
            <TextField
              id="cadastre-address"
              name="entedAddress"
              label={_t("streetOrReference")}
              value={enteredAddress}
              onChange={handleAddressType}
              onKeyDown={() => setIsSelected(false)}
              required
              autoComplete="off"
              placeholder={_t("enterStreetOrReference")}
            />
            <TextField
              id="cadastre-number"
              name="street_number"
              label={_t("number")}
              value={formData.street_number}
              onChange={handleInputChange}
              required
              disabled={!haveValue(formData?.code_ine)}
              placeholder={_t("enterNumber")}
            />
          </div>
          {haveValue(autoCompleteList) &&
            autoCompleteList.length > 0 &&
            haveValue(enteredAddress) &&
            isSelected == false && (
              <ul className="property-suggestions">
                {autoCompleteList.map((ele, index) =>
                  ele.address == "not_found_property" ? null : (
                    <li key={index}>
                      <RowButton
                        type="button"
                        className="property-suggestions__item"
                        onClick={() => handleSelectAddr(ele)}
                      >
                        {ele.address}
                      </RowButton>
                    </li>
                  )
                )}
                <li key={"not_listed_house"}>
                  <RowButton
                    type="button"
                    className="property-suggestions__item property-suggestions__item--muted"
                    onClick={handleRedirectManual}
                  >
                    {_t("myHouseIsNotListed")}
                  </RowButton>
                </li>
              </ul>
            )}
          <Button
            type="submit"
            size="lg"
            block
            iconEnd={<Icon name="arrowRight" size={18} />}
            disabled={
              !haveValue(formData?.code_ine) ||
              !haveValue(formData.street_number)
            }
          >
            {_t("next")}
          </Button>
        </form>
      )}
      {step === 2 && (
        <form className="cadastre__form" onSubmit={handleFloorInput}>
          <div className="property-form__row">
            <TextField
              id="cadastre-address"
              name="entedAddress"
              label={_t("streetOrReference")}
              value={enteredAddress}
              disabled
              placeholder={_t("enterStreetOrReference")}
            />
            <TextField
              id="cadastre-number"
              name="street_number"
              label={_t("number")}
              value={formData.street_number}
              disabled
              placeholder={_t("enterNumber")}
            />
          </div>
          <div className="property-form__row">
            <Select
              id="floor_val"
              name="floor"
              label={_t("floorNumber")}
              placeholder={_t("select")}
              value={formData.floor}
              onChange={(e) => {
                handleInputChange(e);
                setFormData((prev) => ({
                  ...prev,
                  door: "",
                }));
              }}
              options={floorVals.map((floor) => ({
                value: floor,
                label: floor,
              }))}
            />
            <Select
              id="door_val"
              name="door"
              label={_t("letter")}
              placeholder={_t("select")}
              value={formData.door}
              onChange={handleInputChange}
              options={
                haveValue(formData?.floor) && doorVals[formData?.floor]
                  ? Object.keys(doorVals[formData?.floor]).map((door) => ({
                      value: door,
                      label: door,
                    }))
                  : []
              }
            />
          </div>
          <p className="property-form__manual">
            {_t("cantFindYourAddress")}?
            <Button
              variant="secondary"
              size="sm"
              onClick={handleRedirectManual}
            >
              {_t("enterManually")}
            </Button>
          </p>
          <Button
            type="submit"
            size="lg"
            block
            onClick={addVals}
            iconEnd={<Icon name="arrowRight" size={18} />}
            disabled={!haveValue(formData?.floor) || !haveValue(formData?.door)}
          >
            {_t("findProperty")}
          </Button>
        </form>
      )}
      {step === 3 && (
        <form className="cadastre__form" onSubmit={handleManualSubmit}>
          <SearchSelect
            id="cadastre-street-type"
            label={_t("streetType")}
            value={formData?.street_type || ""}
            options={streetTypeOptions}
            placeholder={_t("enterStreetType")}
            onChange={(value) => setField("street_type", value)}
            error={requiredError("street_type", "streetType")}
          />
          <div className="property-form__row">
            <TextField
              id="cadastre-street"
              name="street"
              label={_t("street")}
              value={formData?.street}
              onChange={handleInputChange}
              required
              placeholder={_t("enterStreet")}
            />
            <TextField
              id="cadastre-street-number"
              name="street_number"
              label={_t("number")}
              value={formData?.street_number}
              onChange={handleInputChange}
              required
              placeholder={_t("enterNumber")}
            />
          </div>
          <div className="property-form__row">
            <TextField
              id="cadastre-postcode"
              name="postcode"
              label={_t("postCode")}
              value={formData?.postcode}
              onChange={handleInputChange}
              required
              placeholder={_t("enterPostCode")}
            />
            <TextField
              id="cadastre-staircase"
              name="staircase"
              label={_t("stairway")}
              value={formData?.staircase}
              onChange={handleInputChange}
              required
              placeholder={_t("Enter Stairway")}
            />
          </div>
          <div className="property-form__row">
            <TextField
              id="cadastre-floor"
              name="floor"
              label={_t("floorNumber")}
              value={formData?.floor}
              onChange={handleInputChange}
              required
              placeholder={_t("enterFloorNumber")}
            />
            <TextField
              id="cadastre-door"
              name="door"
              label={_t("letter")}
              value={formData?.door}
              onChange={handleInputChange}
              required
              placeholder={_t("enterLetter")}
            />
          </div>
          <div className="property-form__row">
            <SearchSelect
              id="cadastre-province"
              label={_t("province")}
              value={formData?.province || ""}
              options={provinceOptions}
              placeholder={_t("selectProvince")}
              onChange={(value) => {
                setField("province", value);
                setField("municipality", "");
              }}
              error={requiredError("province", "province")}
            />
            <SearchSelect
              id="cadastre-municipality"
              label={_t("municipality")}
              value={formData?.municipality || ""}
              options={municipalityOptions}
              placeholder={
                formData?.province
                  ? _t("selectMunicipality")
                  : _t("selectProvinceFirst")
              }
              onChange={(value) => setField("municipality", value)}
              disabled={!formData?.province}
              error={requiredError("municipality", "municipality")}
            />
          </div>
          <TextField
            id="cadastre-property-reference"
            name="property_reference"
            label={_t("propertyReferenceOptional")}
            value={formData?.property_reference}
            onChange={handleInputChange}
            placeholder={_t("enterPropertyReference")}
          />
          <Button type="submit" size="lg" block>
            {_t("submit")}
          </Button>
        </form>
      )}
      {step === 4 && (
        <form
          className="cadastre__form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(e);
          }}
        >
          <SearchSelect
            id="cadastre-province"
            label={_t("province")}
            value={formData?.province || ""}
            options={provinceOptions}
            placeholder={_t("selectProvince")}
            onChange={(value) => {
              setField("province", value);
              setField("municipality", "");
            }}
          />
          <SearchSelect
            id="cadastre-municipality"
            label={_t("municipality")}
            value={formData?.municipality || ""}
            options={municipalityOptions}
            placeholder={
              formData?.province
                ? _t("selectMunicipality")
                : _t("selectProvinceFirst")
            }
            onChange={(value) => setField("municipality", value)}
            disabled={!formData?.province}
          />
          <Button type="submit" size="lg" block>
            {_t("submit")}
          </Button>
        </form>
      )}
    </div>
  );
};

export default Cadastre;
